import React from 'react';
import { useNumberInput } from '../../../../logic/otherUtilities/useNumberInput';
import VoxelInput from '../../../voxel/Forms/VoxelInput';
import VoxelMenuItemContainer from '../../../voxel/PopoverMenu/VoxelMenuItemContainer';
import { HeadCellImplementationProps } from '../KeywordTable/HeadCells/models';
import HeadCell from './HeadCell';
import HeadCellStandardOptions from './HeadCellStandardOptions';

export interface HeadCellNumberProps extends HeadCellImplementationProps {
  // Filter state
  allowNegative?: boolean;
  minFilterState?: number;
  maxFilterState?: number;
  setMinFilterState?: (state?: number) => void;
  setMaxFilterState?: (state?: number) => void;
}

export const HeadCellNumber: React.FC<HeadCellNumberProps> = ({
  minFilterState,
  maxFilterState,
  allowNegative,
  setMinFilterState,
  setMaxFilterState,
  basicConfig,
  basicState,
  children,
}) => {
  const minNumberInput = useNumberInput(minFilterState, setMinFilterState, allowNegative);
  const maxNumberInput = useNumberInput(maxFilterState, setMaxFilterState, allowNegative);

  return (
    <HeadCell
      hasFilter={minFilterState !== undefined || maxFilterState !== undefined}
      basicConfig={basicConfig}
      basicState={basicState}
    >
      <div className="w-60">
        <VoxelMenuItemContainer size="md">
          <HeadCellStandardOptions basicConfig={basicConfig} basicState={basicState} />
          {children}
          <div className="flex flex-row items-center gap-3 p-2">
            <VoxelInput
              labelPosition="top"
              label="Min filter"
              placeholder={'0'}
              autoFocus
              size={'sm'}
              value={minNumberInput.textInput}
              onChange={(event) => minNumberInput.handleChangeTextInput(event.target.value)}
              deleteValue={() => minNumberInput.handleChangeTextInput(null)}
            />
            <VoxelInput
              labelPosition="top"
              size={'sm'}
              label="Max filter"
              placeholder={'0'}
              value={maxNumberInput.textInput}
              onChange={(event) => maxNumberInput.handleChangeTextInput(event.target.value)}
              deleteValue={() => maxNumberInput.handleChangeTextInput(null)}
            />
          </div>
        </VoxelMenuItemContainer>
      </div>
    </HeadCell>
  );
};

export default HeadCellNumber;
